export class NativeStreamAggregationSpans {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "lateRows",
            "baseName": "lateRows",
            "type": "NativeStreamAggregationLateRows",
            "format": ""
        },
        {
            "name": "sealDelayMinutes",
            "baseName": "sealDelayMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "layout",
            "baseName": "layout",
            "type": "NativeStreamAggregationSpanLayout",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamAggregationSpans.attributeTypeMap;
    }
    constructor() {
    }
}
